import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import MediaQuery from 'react-responsive';
import {Link, browserHistory} from 'react-router';
import CONSTANTS from '../common_constants';
import ConfirmDeleteComponent from '../components/confirm_box/confirm_box';

export default class ShipmentDetail extends React.Component{
    constructor(props){
      super(props);
      this.state = {
         shipment: props.shipment
      }
      this.formatShipmentData = this.formatShipmentData.bind(this);
    }
    navigateToShipmentDetailPage(shipmentId, shipmentStatus , shipmentType, isShipper){

      if(shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.SHIPMENT_CREATION_COMPLETE_WITH_OFFERS && isShipper){
        return browserHistory.push('/shipment-offers/' + shipmentId);
      }
      else if( shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.SHIPMENT_CREATION_COMPLETE_WITH_NO_OFFERS ||
          shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED ||
          (!isShipper && shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.SHIPMENT_CREATION_COMPLETE_WITH_OFFERS)
        ) {
          return browserHistory.push('/shipment/' + shipmentId + '?backTo=' + this.props.backTo);
      }else if (shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DRAFT ) {
          if(shipmentType == 1) //post a shipment
          {
            this.props.postAShipmentActions.clearPostAShipmentDetails();
            return browserHistory.push('/post-a-shipment/upload-photo?shipmentId='+ shipmentId);
          }else if(shipmentType == 2){   //request an item
            this.props.requestAnItemActions.clearRequestDetails();
            return browserHistory.push('/request-an-item/request-details?shipmentId='+ shipmentId);
          }
      }
      return browserHistory.push('/track-shipment/' + shipmentId);
    }

    formatShipmentData(shipment){
      const {props} = this;
      return({
        shipmentId: shipment.shipmentId,
        name: shipment.title,
        imageUrl: shipment.thumbnailImage,
        deliverTo: props.isReceiving ? shipment.deliverTo.name : shipment.deliverTo,
        deliveryLocation: shipment.deliveryLocation,
        deliveryDate: shipment.deliveryDate ? "Deliver by " + moment(shipment.deliveryDate).format("ll"): '',
        carrierName: shipment.carrierName,
        carrierImageUrl:shipment.carrierProfileImageUrl,
        deliveredDate: shipment.deliveredDate ? "Delivered " + moment(shipment.deliveredDate).format("llll") : '',
        shipperName: shipment.shipperName || '',
        shipperImageUrl:shipment.shipperProfileImageUrl || '',
        pickupLocation: (shipment.pickupLandmark ? shipment.pickupLandmark + ", " : '') + shipment.pickupLocation,
        pickupDate: shipment.pickupDate ? "on " + moment(shipment.pickupDate).format("llll") : '',
        shipmentStatus: shipment.shipmentStatus,
        shipmentType: shipment.shipmentType,
        noOfOffers: shipment.noOfOffers,
        isShipper: shipment.isShipper,
        isBlocked:shipment.isBlocked
      })
    }
    render(){
      const {state, props} = this;
      const self = this;
      const shipment = this.formatShipmentData(props.shipment);
      let defaultImgUrl = "../../public/images/requester_flow/placeholder.png";
      let defaultProfileImgUrl = "../../public/images/user_placeholder.svg";
      if(!shipment.carrierImageUrl && !shipment.shipperImageUrl)
      {
        shipment.carrierImageUrl = defaultProfileImgUrl;
        shipment.shipperImageUrl = defaultProfileImgUrl;
      }

      let showCancelShipment = false , cancelShipmentTitle ;
      if(props.shipmentSection && props.shipmentSection != CONSTANTS.shipmentSection.IM_RECEIVING)
        showCancelShipment = true;
      if(this.props.backTo == "shipping"){
          cancelShipmentTitle = "Cancel Shipment"
      }else if (this.props.backTo == "carrying") {
          cancelShipmentTitle = "Cancel Offer"
      }
      if(!shipment.imageUrl || shipment.imageUrl =="")
        shipment.imageUrl = defaultImgUrl;


      return(
          <div className = {classNames("shipment", {"waiting-shipments":props.waiting})}
               onClick={this.navigateToShipmentDetailPage.bind(this,shipment.shipmentId,shipment.shipmentStatus,shipment.shipmentType,props.isShipper)}>
            <div className = "shipment-content-wrap shipment-package-info">
              { shipment.imageUrl && <div className = "shipment-image-wrap"><div className = "shipment-image"  style={{
                                "backgroundImage": 'url("' + shipment.imageUrl + '")'
                    }} ></div></div> }
              <div className = "shipment-package-content">
                { shipment.shipmentType === 2 && <h6 className = "item-request"><div className="item-request-img"></div>Item Request</h6>}
                { shipment.name && <h3 className = "shipment-name">{shipment.name}</h3> }
                { shipment.deliverTo && <div className = "shipment-data deliver-info"><span className="shipment-details-header">To:&nbsp;</span>{shipment.deliverTo} | {shipment.deliveryLocation}</div> }
                { shipment.deliveryDate && <div className = "shipment-data deliver-date">{shipment.deliveryDate}</div> }
                {
                  shipment.noOfOffers>0 && shipment.shipmentStatus===CONSTANTS.SHIPMENT_STATUSARR.SHIPMENT_CREATION_COMPLETE_WITH_OFFERS &&
                  <div className = "shipment-data offers">{shipment.noOfOffers} New {shipment.noOfOffers>1 ? "Offers" : "Offer"}</div>
                }
              </div>
            </div>

              {
                !shipment.isBlocked &&
                  <MediaQuery query='(min-width: 768px)'>
                    <div className = "shipment-content-wrap carrier-info">
                      {
                        (shipment.carrierImageUrl || shipment.shipperImageUrl) && (shipment.carrierName || shipment.shipperName) &&
                          <div className = "carrier-image-wrap">
                            <img className = "carrier-image" src = {shipment.carrierImageUrl || shipment.shipperImageUrl}/>
                          </div>
                      }
                      {
                        (shipment.carrierName || shipment.shipperName) &&
                        <div className = "carrier-data">
                          <h5 className = "shipment-data carrier-header">{shipment.carrierName ? "Carrier" : "Shipper"}</h5>
                          <h5 className = "shipment-data carrier-name">{shipment.carrierName || shipment.shipperName}</h5>
                        </div>
                      }
                      {
                        showCancelShipment &&
                        <div className = "cancel-shipment-section" onClick = {this.props.toggleShowConfirmBox.bind(this , self.props.shipment.shipmentId)}>
                            {cancelShipmentTitle}
                        </div>
                      }
                    </div>
                  </MediaQuery>
            }
            {
              shipment.isBlocked && <MediaQuery query='(min-width: 768px)'><div className = "info-unavailable">User Information Unavailable</div></MediaQuery>
            }

            <div className = "shipment-content-wrap pickup-info">
              <MediaQuery query='(max-width: 767px)'>
                {
                  shipment.isBlocked && <div className = "info-unavailable">User Information Unavailable</div>
                }
              </MediaQuery>
              { props.delivered && <div className = "shipment-data delivered-info">{shipment.deliveredDate}</div> }

              {
                !props.delivered && shipment.pickupLocation != "null"?
                <div className = "shipment-data pickup-location">
                  <span className="shipment-details-header">Pickup at&nbsp;</span>
                  {shipment.pickupLocation}
                </div>
                 : ''
              }
              <MediaQuery query='(max-width: 767px)'>
                {
                  showCancelShipment &&
                  <div className = "cancel-shipment-section" onClick = {this.props.toggleShowConfirmBox.bind(this , self.props.shipment.shipmentId)}>
                      {cancelShipmentTitle}
                  </div>
                }

              </MediaQuery>
              { !props.delivered && <div className = "shipment-data pickup-date">{shipment.pickupDate}</div> }
            </div>
          </div>
      )
    }
}



// WEBPACK FOOTER //
// app/dashboard/shipment_detail.jsx